import type { DeleteAppetitesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteAppetitesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteAppetites = createMutationHook({
  name: 'deleteAppetites',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.appetite.delete.mutationOptions({ onSuccess }),
  mapInput: (ids: string[]) => ({ ids }),
  invalidate: (trpc) => [
    trpc.frontend.appetite.register.queryKey(),
    trpc.frontend.appetite.getById.queryKey(),
    trpc.frontend.appetite.appetitesByRiskId.queryKey(),
    trpc.frontend.appetite.activeAppetitesByParentId.queryKey(),
    trpc.frontend.appetite.getAppetitesGroupedByImpact.queryKey(),
    // COI-471 parity: Apollo twin evicts the `risk` field (appetites
    // surface on the linked risk).
    trpc.frontend.risk.pathKey(),
  ],
  mapResponse: (): DeleteAppetitesMutation => ({
    delete_appetite: {
      __typename: 'appetite_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: DeleteAppetitesDocument,
  graphqlVariables: (ids: string[]) => ({ Ids: ids }),
  evictFields: ['appetite', 'appetite_aggregate', 'risk_aggregate'],
});
